import {
  Box,
  Icon,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  Text,
  Tooltip,
  useDisclosure,
  useMediaQuery,
  useToast
} from '@chakra-ui/react';
import { AxiosResponse } from 'axios';
import { useContext, useEffect, useRef, useState } from 'react';
import { AiOutlineInfoCircle } from 'react-icons/ai';
import { IoCloseOutline } from 'react-icons/io5';
import { Link } from 'react-router-dom';

import { DetalhesIcon } from '../../../../../assets/icons/DetalhesIcon';
import { LupaIcon } from '../../../../../assets/icons/LupaIcon';
import { OlhoIcon } from '../../../../../assets/icons/OlhoIcon';
import { Spinner } from '../../../../../components/widgets/Spinner';
import FilterContext from '../../../../../contexts/FilterContext';
import useTable from '../../../../../hooks/useTable';
import { api } from '../../../../../services/api';
import { apiSensedia } from '../../../../../services/api-sensedia';
import { PaginateDot } from './PaginateDot';

const TablePerfis = ({ rowsPerPage, visualization }: any) => {
  const initialStateGestor = [];
  const initialStateVendedor = [];

  const [userInative, setUserInative] = useState({
    nome: '',
    id: '',
    status: '',
    tipo: ''
  });
  const ref = useRef(null);
  const [loading, setLoading] = useState(false);
  const [loadingAlterarStatus, setLoadingAlterarStatus] = useState(false);
  const [notFound, setNotFound] = useState(false);
  const [isMobile] = useMediaQuery('(max-width: 920px)');
  const [filterTextState, setFilterTextState] = useState('');
  const [vendedoresOriginais, setVendedoresOriginais] =
    useState(initialStateVendedor);
  const [gestoresOriginais, setGestoresOriginais] =
    useState(initialStateGestor);
  const [page, setPage] = useState(1);
  const [vendedores, setVendedores] = useState(initialStateVendedor);
  const [gestores, setGestores] = useState(initialStateGestor);

  const { filterObject, setFilterObject } = useContext(FilterContext);
  const {
    onClose: onCloseInativar,
    isOpen: isOpenInativar,
    onOpen: onOpenInativar
  } = useDisclosure();
  const toast = useToast();

  const onFilterText = (
    nome: string,
    codigo_produtor: string,
    id_vendedor: string
  ) => {
    if (
      nome?.toLowerCase().includes(filterTextState.toLowerCase()) ||
      codigo_produtor?.toLowerCase().includes(filterTextState.toLowerCase()) ||
      id_vendedor?.toLowerCase().includes(filterTextState.toLowerCase()) ||
      filterTextState === '' ||
      filterTextState === null ||
      filterTextState === undefined
    ) {
      return false;
    }

    return true;
  };

  const { slice, range } = useTable(vendedores, page, rowsPerPage);

  const getData = async () => {
    setLoading(true);

    try {
      let res = {} as AxiosResponse;

      try {
        res = await apiSensedia.get(
          `/oportunidades-sulamerica/painel-leads/gestao?count=true`,
          {
            timeout: 0
          }
        );
        console.log(res);
      } catch (e: any) {
        const errorObj = e?.toJSON();
        toast({
          position: 'top',
          description: (
            <Box>
              <Text>
                {' '}
                Ocorreu um erro. Esvazie o cache do navegador, aguarde alguns
                minutos e tente fazer login novamente, se persistir, por favor
                entrar em contato.
              </Text>
              <Text>
                {errorObj?.status && (
                  <>
                    <br />
                    <b>Detalhes:</b>
                    <br />
                  </>
                )}
                {(errorObj?.status || e?.response?.data?.statusCode) && (
                  <>{errorObj.status ?? e.response.data.statusCode}</>
                )}
                {errorObj?.status &&
                  (e?.response?.data?.message || errorObj?.message) &&
                  ' - '}
                {(e?.response?.data?.message || errorObj?.message) && (
                  <>{e.response.data.message ?? errorObj.message}</>
                )}
              </Text>
            </Box>
          ),
          duration: 15000,
          isClosable: true,
          status: 'error'
        });
      }

      const vendedores = res.data.perfis.filter(
        (vendedor: any) =>
          vendedor.tipo === 'clt' || vendedor.tipo === 'autonomo'
      );

      setVendedores(vendedores);
      setVendedoresOriginais(vendedores);

      const gestores = res.data.perfis.filter(
        (gestor: any) => gestor.tipo === 'gestor'
      );

      setGestores(gestores);
      setGestoresOriginais(gestores);

      setLoading(false);
    } catch (error: any) {
      setLoading(false);
    }
  };

  const handleAlterarStatusUsuario = async () => {
    setLoadingAlterarStatus(true);

    try {
      const { data } = await apiSensedia.put(
        `oportunidades-sulamerica/painel-leads/alterar-status-usuario`,
        {
          id: userInative.id,
          status: userInative.status
        }
      );

      setLoadingAlterarStatus(false);

      setVendedores((prevVendedores) =>
        prevVendedores.map((vendedor) =>
          vendedor.id === userInative.id
            ? { ...vendedor, status: userInative.status }
            : vendedor
        )
      );
      toast({
        position: 'top',
        description: 'Status do usuário atualizado com sucesso.',
        status: 'success',
        duration: 7000,
        isClosable: true
      });
      onCloseInativar();
    } catch (error: any) {
      toast({
        position: 'top',
        description: 'Ocorreu um error, favor tente novamente',
        status: 'error',
        duration: 7000,
        isClosable: true
      });
      setLoadingAlterarStatus(false);
    }
  };

  const handleFiltro = async () => {
    setLoading(true);
    const vendedoresFiltrados = vendedoresOriginais.filter((vendedor) => {
      const validateText = onFilterText(
        vendedor.nome,
        vendedor.codigo_produtor,
        vendedor.id
      );
      if (!validateText) {
        return vendedor;
      }
    });

    const gestoresFiltrados = gestoresOriginais.filter((gestor) => {
      const validateText = onFilterText(
        gestor.nome,
        gestor.codigo_produtor,
        gestor.id
      );
      if (!validateText) {
        return gestor;
      }
    });

    setGestores(gestoresFiltrados);
    setVendedores(vendedoresFiltrados);

    if (vendedoresFiltrados?.length === 0) {
      setNotFound(true);
      setLoading(false);
      return;
    }

    setNotFound(false);
    setLoading(false);
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <div className="tw-w-[100%] tw-text-[#001E64]">
        <div
          className={
            isMobile
              ? 'tw-w-[100%] tw-flex tw-flex-col tw-justify-between tw-mt-[2vh] tw-mb-[3vh]'
              : 'tw-w-[100%] tw-flex tw-justify-between tw-mt-[2vh] tw-mb-[3vh]'
          }
        >
          <div>
            <p
              className={
                isMobile
                  ? 'tw-text-[#323232] tw-font-bold tw-text-[1.25rem] tw-text-center'
                  : 'tw-text-[#323232] tw-font-bold tw-text-[3vh]'
              }
            >
              Acompanhamento de perfis
            </p>
            <p className={isMobile ? 'tw-text-center tw-text-[1rem]' : ''}>
              Quantidade de perfis:{' '}
              <span className={'tw-font-bold'}>
                {vendedores.length + gestores.length}
              </span>
            </p>
          </div>
          <div
            className={
              isMobile
                ? 'tw-flex tw-flex-col tw-items-center'
                : 'tw-flex tw-flex-row tw-items-center'
            }
          >
            <form
              className={
                isMobile
                  ? 'tw-rounded-3xl tw-flex tw-w-[100%]'
                  : 'tw-rounded-3xl tw-flex '
              }
            >
              <div
                className={
                  isMobile
                    ? 'tw-flex tw-items-center  tw-rounded-[1.85rem_0_0_1.85rem]  tw-w-[100%] tw-pl-[1vw] tw-border-[0.1rem] tw-border-r-[0] tw-border-[#001E64] '
                    : 'tw-flex tw-items-center  tw-rounded-[1.85rem_0_0_1.85rem]  xl:tw-w-[14rem] 2xl:tw-w-[14vw] tw-pl-[1vw] tw-border-[0.1rem] tw-border-r-[0] tw-border-[#001E64] '
                }
              >
                <input
                  className="tw-bg-transparent tw-w-[100%] tw-py-[1vh] tw-px-[10px]"
                  placeholder="Digite o nome do vendedor"
                  value={filterTextState}
                  onChange={(e) => {
                    setFilterTextState(e.target.value);
                  }}
                />
                {filterTextState && (
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      setGestores(gestoresOriginais);
                      setFilterTextState('');
                    }}
                  >
                    <IoCloseOutline size="1.5rem" />
                  </button>
                )}
              </div>
              <button
                type="reset"
                onClick={(e) => {
                  e.preventDefault();
                  handleFiltro();
                }}
                className={
                  isMobile
                    ? 'tw-bg-[#FF5000] tw-rounded-[0_1.85rem_1.85rem_0] tw-py-[0.95vh] tw-w-[4rem] tw-border-[0.1rem] tw-border-l-[0] tw-border-[#001E64] '
                    : 'tw-bg-[#FF5000] tw-rounded-[0_1.85rem_1.85rem_0] tw-py-[0.95vh] 2xl:tw-w-[2.2vw] xl:tw-w-[3vw] tw-border-[0.1rem] tw-border-l-[0] tw-border-[#001E64] '
                }
              >
                <LupaIcon w="1.5rem" h="1.5rem" />
              </button>
            </form>
          </div>
        </div>
        {!isMobile && (
          <>
            {!loading ? (
              <>
                <table className="tw-w-[100%] tw-border-separate [border-spacing:0_0.75rem]">
                  <thead>
                    <tr className="tw-text-left xl:tw-text-[0.8rem] 2xl:tw-text-[1rem]">
                      <th className="tw-pl-[2vw]">
                        {gestores?.length > 0 ? 'Gestor' : 'Vendedor'}
                      </th>
                      <th className="xl:tw-text-[0.8rem] 2xl:tw-text-[1rem]">
                        ID Vendedor
                      </th>
                      <th className="xl:tw-text-[0.8rem] 2xl:tw-text-[1rem]">
                        Leads <br />
                        recebidos
                      </th>
                      <th className="xl:tw-text-[0.8rem] 2xl:tw-text-[1rem]">
                        Leads <br /> atendidos
                      </th>
                      <th className="xl:tw-text-[0.8rem] 2xl:tw-text-[1rem]">
                        Leads <br /> não atendidos
                      </th>
                      <th className="tw-flex tw-items-center tw-gap-1 xl:tw-text-[0.8rem] 2xl:tw-text-[1rem]">
                        Taxa <br /> de sucesso{' '}
                        <Tooltip
                          label={
                            <span>
                              <span className="tw-font-bold">
                                Taxa de sucesso <br />{' '}
                              </span>
                              <span>
                                Leads finalizados com <br />
                                sucesso / leads totais recebidos
                              </span>
                            </span>
                          }
                          placement="bottom"
                          hasArrow
                        >
                          <a>
                            <AiOutlineInfoCircle
                              size="1.3rem"
                              color="#5A5A5A"
                            />
                          </a>
                        </Tooltip>
                      </th>
                      <th className="xl:tw-text-[0.8rem] 2xl:tw-text-[1rem]">
                        Leads hot
                      </th>
                      {/* <th className="xl:tw-text-[0.8rem] 2xl:tw-text-[1rem]">
                        Relação
                      </th> */}
                      <th className="xl:tw-text-[0.8rem] 2xl:tw-text-[1rem]">
                        Ação
                      </th>
                      <th className="xl:tw-text-[0.8rem] 2xl:tw-text-[1rem]">
                        Status
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {gestores.map((el: any, index: any) => {
                      // if (onFilterText(el.nome, el.codigo_produtor, el.tipo)) {
                      //   return;
                      // }
                      return (
                        <tr
                          key={index}
                          className={`${
                            +index % 2 > 0
                              ? 'tw-bg-[#F4F4F4]'
                              : 'tw-bg-[#E9EEF6]'
                          } tw-rounded-2xl tw-h-[6vh]`}
                        >
                          <td className="tw-border-l-[0.3rem] tw-border-solid tw-border-[#FF5000] tw-rounded-[0.4rem_0_0_0.4rem] tw-pl-[2vw] ">
                            {el.nome}
                          </td>
                          <td>{el.id}</td>
                          <td>{el.quantidade_leads_recebidos}</td>
                          <td>{el.quantidade_leads_atendidos}</td>
                          <td>{el.quantidade_leads_naoAtendidos}</td>
                          <td>{el.taxa_sucesso}</td>
                          <td>{el.quantidade_leads_leadsHot}</td>
                          <td>-</td>
                          <td></td>
                          <td></td>
                        </tr>
                      );
                    })}
                  </tbody>
                  {notFound !== true && (
                    <thead>
                      <tr className="tw-text-left">
                        <th className="tw-pl-[2vw] xl:tw-text-[0.8rem] 2xl:tw-text-[1rem]">
                          {gestores?.length > 0 ? 'Vendedor' : ''}
                        </th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                      </tr>
                    </thead>
                  )}
                  <tbody>
                    {slice.map((el: any, index: any) => {
                      // if (
                      //   onFilterText(el.nome, el.codigo_produtor, el.tipo) ||
                      //   onFilterSelect(el.tipo)
                      // ) {
                      //   return;
                      // }
                      return (
                        <tr
                          key={index}
                          className={`${
                            +index % 2 > 0
                              ? 'tw-bg-[#F4F4F4]'
                              : 'tw-bg-[#E9EEF6]'
                          } tw-rounded-2xl tw-h-[6vh]`}
                        >
                          <td className="tw-border-l-[0.3rem] tw-border-solid tw-border-[#FF5000] tw-rounded-[0.4rem_0_0_0.4rem] tw-pl-[2vw] ">
                            {el.nome}
                          </td>
                          <td>{el.id}</td>
                          <td>{el.quantidade_leads_recebidos}</td>
                          <td>{el.quantidade_leads_atendidos}</td>
                          <td>{el.quantidade_leads_naoAtendidos}</td>
                          <td>{el.taxa_sucesso}</td>
                          <td>{el.quantidade_leads_leadsHot}</td>
                          <td>
                            <Tooltip
                              label="Painel do corretor"
                              placement="top"
                              hasArrow
                            >
                              <Link
                                to={'/corretor/leads/kanban'}
                                onClick={() => {
                                  setFilterObject({
                                    ...filterObject,
                                    headers: {
                                      ...filterObject.headers,
                                      login: el.id
                                    }
                                  });
                                }}
                              >
                                <DetalhesIcon />
                              </Link>
                            </Tooltip>
                            <Tooltip
                              label="Detalhes do corretor"
                              placement="top"
                              hasArrow
                            >
                              <Link
                                to={'/corretor/leads/vendedor'}
                                state={{ vendedor: el, perfis: slice }}
                              >
                                <OlhoIcon h="1.5rem" w="1.5rem" />
                              </Link>
                            </Tooltip>
                          </td>
                          <td
                            onClick={() => {
                              onOpenInativar();

                              setUserInative({
                                ...userInative,
                                nome: el.nome,
                                tipo: el.tipo,
                                id: el.id,
                                status:
                                  el.status === 'ativo' ? 'inativo' : 'ativo'
                              });
                            }}
                            className="tw-text-[#E9EEF6] tw-cursor-pointer"
                          >
                            <span
                              className={`tw-px-[1vh] tw-py-[0.5vh] tw-rounded-[0.4rem_0_0_0.4rem] ${
                                el.status === 'inativo'
                                  ? 'tw-bg-[#323232]'
                                  : 'tw-bg-[#AAAAAA]'
                              }`}
                            >
                              Inativo
                            </span>

                            <span
                              className={`tw-px-[1vh] tw-py-[0.5vh] tw-rounded-[0_0.4rem_0.4rem_0] ${
                                el.status === 'ativo'
                                  ? 'tw-bg-[#146EFA]'
                                  : 'tw-bg-[#AAAAAA]'
                              }`}
                            >
                              Ativo
                            </span>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                {notFound === true && gestores?.length === 0 && (
                  <div className="tw-flex tw-flex-col tw-w-[100%] tw-items-center tw-justify-center tw-my-6">
                    <svg
                      width="75"
                      height="75"
                      viewBox="0 0 75 75"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M37.5 0C58.2113 0 75 16.7887 75 37.5C75 40.2262 74.7113 42.8812 74.1562 45.4425L67.4737 38.7562C67.7489 32.1741 65.8498 25.6843 62.0695 20.2889C58.2893 14.8935 52.8381 10.8924 46.5576 8.90333C40.2771 6.91428 33.5165 7.04787 27.3195 9.28346C21.1225 11.5191 15.8337 15.7323 12.2695 21.2729C8.70535 26.8134 7.06405 33.3731 7.59899 39.9393C8.13393 46.5055 10.8154 52.713 15.2294 57.6036C19.6433 62.4942 25.5444 65.7958 32.0216 66.9988C38.4987 68.2019 45.1918 67.2394 51.0675 64.26C52.4988 66.5285 54.5126 68.3713 56.8988 69.5962C51.0495 73.1403 44.3391 75.0095 37.5 75C16.7888 75 0 58.2112 0 37.5C0 16.7887 16.7888 0 37.5 0ZM63.75 45.645L69.0525 50.9475C70.0847 51.9793 70.7934 53.2899 71.0918 54.7186C71.3901 56.1473 71.2651 57.632 70.7321 58.9907C70.1991 60.3494 69.2812 61.5231 68.091 62.3678C66.9008 63.2126 65.49 63.6917 64.0315 63.7465C62.573 63.8012 61.1303 63.4292 59.8801 62.6761C58.6299 61.923 57.6266 60.8214 56.9932 59.5065C56.3598 58.1916 56.1238 56.7205 56.3142 55.2734C56.5046 53.8264 57.1131 52.4663 58.065 51.36L58.4475 50.9475L63.75 45.645ZM37.5 48.75C42.9975 48.75 47.9437 51.1162 51.375 54.8887L47.8312 58.1137C44.8688 56.9325 41.3175 56.25 37.5 56.25C33.6825 56.25 30.1313 56.9362 27.1687 58.11L23.625 54.885C25.3808 52.9498 27.5226 51.404 29.9125 50.3474C32.3023 49.2907 34.887 48.7465 37.5 48.75ZM24.375 30C25.8668 30 27.2976 30.5926 28.3525 31.6475C29.4074 32.7024 30 34.1332 30 35.625C30 37.1168 29.4074 38.5476 28.3525 39.6025C27.2976 40.6574 25.8668 41.25 24.375 41.25C22.8832 41.25 21.4524 40.6574 20.3975 39.6025C19.3426 38.5476 18.75 37.1168 18.75 35.625C18.75 34.1332 19.3426 32.7024 20.3975 31.6475C21.4524 30.5926 22.8832 30 24.375 30ZM50.625 30C52.1168 30 53.5476 30.5926 54.6025 31.6475C55.6574 32.7024 56.25 34.1332 56.25 35.625C56.25 37.1168 55.6574 38.5476 54.6025 39.6025C53.5476 40.6574 52.1168 41.25 50.625 41.25C49.1332 41.25 47.7024 40.6574 46.6475 39.6025C45.5926 38.5476 45 37.1168 45 35.625C45 34.1332 45.5926 32.7024 46.6475 31.6475C47.7024 30.5926 49.1332 30 50.625 30Z"
                        fill="#D2D2D2"
                      />
                    </svg>
                    <p className="tw-mt-2 tw-text-[#828282]">
                      Sua pesquisa não encontrou nenhum nome de vendedor
                      correspondente.{' '}
                    </p>
                  </div>
                )}
              </>
            ) : (
              <div className="tw-flex tw-justify-center">
                <Spinner />
              </div>
            )}
          </>
        )}
      </div>
      {isMobile && (
        <div className="tw-text-[0.9rem] tw-text-[#001E64]">
          <p className="tw-font-bold tw-text-[1.3rem] tw-mb-2">
            {gestores?.length > 0 ? 'Gestor' : 'Vendedor'}
          </p>
          {gestores.map((el: any, index: any) => {
            return (
              <div
                key={index}
                className={`${
                  +index % 2 > 0 ? 'tw-bg-[#F4F4F4]' : 'tw-bg-[#E9EEF6]'
                } tw-rounded-2xl tw-border-l-[0.3rem] tw-border-solid tw-border-[#FF5000] tw-flex tw-flex-col tw-gap-1 tw-p-4 `}
              >
                <div className="">
                  Gestor - <span className="tw-font-bold">{el.nome}</span>
                </div>
                <div>
                  ID Vendedor - <span className="tw-font-bold">{el.id}</span>
                </div>
                <div>
                  Leads recebidos -{' '}
                  <span className="tw-font-bold">
                    {el.quantidade_leads_recebidos}
                  </span>
                </div>
                <div>
                  Leads atendidos -{' '}
                  <span className="tw-font-bold">
                    {el.quantidade_leads_atendidos}
                  </span>
                </div>
                <div>
                  Leads não atendidos -{' '}
                  <span className="tw-font-bold">
                    {el.quantidade_leads_naoAtendidos}
                  </span>
                </div>
                <div>
                  Taxa de sucesso -{' '}
                  <span className="tw-font-bold">{el.taxa_sucesso}</span>
                </div>
                <div>
                  Leads hot -{' '}
                  <span className="tw-font-bold">
                    {el.quantidade_leads_leadsHot}
                  </span>
                </div>
              </div>
            );
          })}
          <p className="tw-font-bold tw-text-[1.3rem] tw-my-2">
            {gestores?.length > 0 ? 'Vendedor' : ''}
          </p>
          {slice.map((el: any, index: any) => {
            return (
              <div
                key={index}
                className={`${
                  +index % 2 > 0 ? 'tw-bg-[#F4F4F4]' : 'tw-bg-[#E9EEF6]'
                } tw-rounded-2xl tw-border-l-[0.3rem] tw-flex tw-flex-col tw-mt-2 tw-gap-1 tw-p-4 tw-border-solid tw-border-[#FF5000]`}
              >
                <div className="">Vendedor - {el.nome}</div>
                <div>
                  ID Vendedor - <span className="tw-font-bold">{el.id}</span>
                </div>
                <div>
                  Leads recebidos -{' '}
                  <span className="tw-font-bold">
                    {el.quantidade_leads_recebidos}
                  </span>
                </div>
                <div>
                  Leads atendidos -{' '}
                  <span className="tw-font-bold">
                    {el.quantidade_leads_atendidos}
                  </span>
                </div>
                <div>
                  Leads não atendidos -{' '}
                  <span className="tw-font-bold">
                    {el.quantidade_leads_naoAtendidos}
                  </span>
                </div>
                <div>
                  Taxa de sucesso -{' '}
                  <span className="tw-font-bold">{el.taxa_sucesso}</span>
                </div>
                <div>
                  Leads hot -{' '}
                  <span className="tw-font-bold">
                    {el.quantidade_leads_leadsHot}
                  </span>
                </div>
                {/* <div>
                  Relação{' '}
                  <span
                    className={`tw-rounded-[0.4rem] tw-px-[1vh] tw-py-[0.5vh] tw-text-white ${
                      el.tipo === 'autonomo'
                        ? 'tw-bg-[#001E64]'
                        : 'tw-bg-[#FF5000]'
                    }`}
                  >
                    {el.tipo === 'clt' ? 'CLT' : 'Autônomo'}
                  </span>
                </div> */}
                <div
                  onClick={() => {
                    onOpenInativar();
                    setUserInative({
                      ...userInative,
                      nome: el.nome,
                      id: el.id,
                      status: el.status === 'ativo' ? 'inativo' : 'ativo',
                      tipo: el.tipo
                    });
                  }}
                  className=" tw-cursor-pointer tw-mt-2"
                >
                  Status -{' '}
                  <span
                    className={`tw-px-[1vh] tw-py-[0.5vh]  tw-text-[#E9EEF6] tw-rounded-[0.4rem_0_0_0.4rem] ${
                      el.status === 'inativo'
                        ? 'tw-bg-[#323232]'
                        : 'tw-bg-[#AAAAAA]'
                    }`}
                  >
                    Inativo
                  </span>
                  <span
                    className={`tw-px-[1vh] tw-py-[0.5vh] tw-text-[#E9EEF6] tw-rounded-[0_0.4rem_0.4rem_0] ${
                      el.status === 'ativo'
                        ? 'tw-bg-[#146EFA]'
                        : 'tw-bg-[#AAAAAA]'
                    }`}
                  >
                    Ativo
                  </span>
                </div>
                <div className="tw-flex tw-flex-col tw-gap-2 tw-mt-1">
                  <Link
                    className="tw-font-bold tw-border-[0.1rem] tw-px-4 tw-h-[2.5rem] tw-gap-1 tw-items-center tw-justify-center tw-flex  tw-rounded-full tw-border-[#001E64] tw-text-[#001E64]"
                    to={'/corretor/leads/kanban'}
                    onClick={() => {
                      setFilterObject({
                        ...filterObject,
                        headers: { ...filterObject.headers, login: el.id }
                      });
                    }}
                  >
                    <DetalhesIcon />
                    <span>Ver painel de cards</span>
                  </Link>

                  <Link
                    className="tw-font-bold tw-border-[0.1rem] tw-px-4 tw-h-[2.5rem] tw-gap-1 tw-items-center tw-justify-center tw-flex tw-rounded-full tw-border-[#001E64] tw-text-[#001E64]"
                    to={'/corretor/leads/vendedor'}
                    state={{ vendedor: el, perfis: slice }}
                  >
                    <OlhoIcon h="1.5rem" w="1.5rem" />{' '}
                    <span>Detalhes do vendedor</span>
                  </Link>
                </div>
              </div>
            );
          })}
          {notFound === true && gestores?.length === 0 && (
            <div className="tw-flex tw-flex-col tw-w-[100%] tw-items-center tw-justify-center tw-my-6">
              <svg
                width="75"
                height="75"
                viewBox="0 0 75 75"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M37.5 0C58.2113 0 75 16.7887 75 37.5C75 40.2262 74.7113 42.8812 74.1562 45.4425L67.4737 38.7562C67.7489 32.1741 65.8498 25.6843 62.0695 20.2889C58.2893 14.8935 52.8381 10.8924 46.5576 8.90333C40.2771 6.91428 33.5165 7.04787 27.3195 9.28346C21.1225 11.5191 15.8337 15.7323 12.2695 21.2729C8.70535 26.8134 7.06405 33.3731 7.59899 39.9393C8.13393 46.5055 10.8154 52.713 15.2294 57.6036C19.6433 62.4942 25.5444 65.7958 32.0216 66.9988C38.4987 68.2019 45.1918 67.2394 51.0675 64.26C52.4988 66.5285 54.5126 68.3713 56.8988 69.5962C51.0495 73.1403 44.3391 75.0095 37.5 75C16.7888 75 0 58.2112 0 37.5C0 16.7887 16.7888 0 37.5 0ZM63.75 45.645L69.0525 50.9475C70.0847 51.9793 70.7934 53.2899 71.0918 54.7186C71.3901 56.1473 71.2651 57.632 70.7321 58.9907C70.1991 60.3494 69.2812 61.5231 68.091 62.3678C66.9008 63.2126 65.49 63.6917 64.0315 63.7465C62.573 63.8012 61.1303 63.4292 59.8801 62.6761C58.6299 61.923 57.6266 60.8214 56.9932 59.5065C56.3598 58.1916 56.1238 56.7205 56.3142 55.2734C56.5046 53.8264 57.1131 52.4663 58.065 51.36L58.4475 50.9475L63.75 45.645ZM37.5 48.75C42.9975 48.75 47.9437 51.1162 51.375 54.8887L47.8312 58.1137C44.8688 56.9325 41.3175 56.25 37.5 56.25C33.6825 56.25 30.1313 56.9362 27.1687 58.11L23.625 54.885C25.3808 52.9498 27.5226 51.404 29.9125 50.3474C32.3023 49.2907 34.887 48.7465 37.5 48.75ZM24.375 30C25.8668 30 27.2976 30.5926 28.3525 31.6475C29.4074 32.7024 30 34.1332 30 35.625C30 37.1168 29.4074 38.5476 28.3525 39.6025C27.2976 40.6574 25.8668 41.25 24.375 41.25C22.8832 41.25 21.4524 40.6574 20.3975 39.6025C19.3426 38.5476 18.75 37.1168 18.75 35.625C18.75 34.1332 19.3426 32.7024 20.3975 31.6475C21.4524 30.5926 22.8832 30 24.375 30ZM50.625 30C52.1168 30 53.5476 30.5926 54.6025 31.6475C55.6574 32.7024 56.25 34.1332 56.25 35.625C56.25 37.1168 55.6574 38.5476 54.6025 39.6025C53.5476 40.6574 52.1168 41.25 50.625 41.25C49.1332 41.25 47.7024 40.6574 46.6475 39.6025C45.5926 38.5476 45 37.1168 45 35.625C45 34.1332 45.5926 32.7024 46.6475 31.6475C47.7024 30.5926 49.1332 30 50.625 30Z"
                  fill="#D2D2D2"
                />
              </svg>
              <p className="tw-mt-2 tw-text-[#828282]">
                Sua pesquisa não encontrou nenhum nome de vendedor
                correspondente.{' '}
              </p>
            </div>
          )}
        </div>
      )}
      <div className="tw-flex tw-justify-end tw-w-[100%]">
        <PaginateDot
          currentPage={page}
          lastPage={range}
          maxLength={5}
          setCurrentPage={setPage}
          totalData={vendedores}
        />
      </div>

      <Modal
        closeOnOverlayClick={true}
        isOpen={isOpenInativar}
        onClose={onCloseInativar}
        isCentered
        size="md"
      >
        <ModalOverlay />
        <ModalContent textAlign="center">
          <ModalHeader>
            {userInative.status === 'ativo' ? 'Ativar ' : 'Inativar '}
            vendedor
          </ModalHeader>
          <ModalBody mt="1rem">
            <div>
              <div>
                {userInative.status === 'inativo' ? (
                  <p>
                    Você deseja inativar{' '}
                    <span className="tw-font-bold">({userInative.nome})</span>?
                    <br />
                    Ao inativar, o vendedor não ficará mais
                    <br />
                    disponível para distribuição de leads <br />
                  </p>
                ) : (
                  <p>
                    Você deseja ativar{' '}
                    <span className="tw-font-bold">({userInative.nome})</span>?
                    <br />
                    Ao ativar, o vendedor voltará a ficar
                    <br />
                    disponível para distribuição de leads <br />
                  </p>
                )}
              </div>
            </div>
          </ModalBody>
          <ModalFooter justifyContent="space-between" px="2rem">
            <button
              onClick={onCloseInativar}
              className="tw-font-bold tw-border-[0.2rem] tw-w-[9rem] tw-py-[0.8rem] tw-rounded-full tw-border-[#001E64] tw-text-[#001E64]"
            >
              Cancelar
            </button>

            {loadingAlterarStatus === true ? (
              <button
                disabled
                className="tw-bg-[#FA6B25] tw-flex tw-items-center tw-justify-center  tw-text-[#EBEBEB] tw-font-bold tw-border-[0.1rem] tw-w-[10rem] tw-h-[3.2rem] tw-rounded-3xl"
              >
                <svg
                  className="tw-animate-spin tw-h-5 tw-w-5 tw-mr-3 "
                  viewBox="0 0 24 24"
                >
                  <path
                    xmlns="http://www.w3.org/2000/svg"
                    d="M10.14,1.16a11,11,0,0,0-9,8.92A1.59,1.59,0,0,0,2.46,12,1.52,1.52,0,0,0,4.11,10.7a8,8,0,0,1,6.66-6.61A1.42,1.42,0,0,0,12,2.69h0A1.57,1.57,0,0,0,10.14,1.16Z"
                    className="spinner_P7sC"
                    fill="white"
                  />
                </svg>
                Processando...
              </button>
            ) : (
              <button
                onClick={() => {
                  handleAlterarStatusUsuario();
                }}
                className="tw-font-bold  tw-w-[9rem] tw-py-[0.8rem] tw-rounded-full tw-bg-[#FA6B25] tw-text-[#FFFF]"
              >
                Sim
              </button>
            )}
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default TablePerfis;
